import { HttpErrorService } from '@/services/HttpError.service'
import { geoLocationErrorHandbook } from '@/models/Errors'
import type { GeoLocationResponse } from '@/models'
import { HttpService } from '@/services/Http.service'

export class GeoLocationService {
  private httpErrorService: HttpErrorService<
    keyof typeof geoLocationErrorHandbook
  >

  private endpoint = '/domain'
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      geoLocationErrorHandbook,
      'geoLocation',
    )
  }

  async getLocation() {
    const url = this.endpoint

    return await this.httpService
      .get<GeoLocationResponse>(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
          baseUrl: 'https://go.kassir.ru/api',
          omitCredentials: true,
        },
        fetchConfig: {},
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
